
/// <reference path="../../../setup/_references.ts" />
module onvio.clientDashboard.ClientAssignmentsComponent {
    'use strict';

    export class ClientAssignmentsController {
        public client: cs.IClientWithExpansionV3Dto;
        public partner: cs.IEmployeeWithExpansionV3Dto;
        public manager: cs.IEmployeeWithExpansionV3Dto;
        public associate: cs.IEmployeeWithExpansionV3Dto;
        public isLoading: boolean;

        static $inject = [
            '$translate',
            'bm.core.setup.employees.EmployeeProvider'
        ];
        constructor(
            private $translate: ng.translate.ITranslateService,
            private employeeProvider: bm.core.setup.employees.EmployeeProvider
        ) { }

        $onChanges(changes: any) {
            if (changes.client && changes.client.currentValue && changes.client.currentValue.id) {
                this.loadClientAssignmentsData();
            }
        }

        public getNoAssignmentsString(): string {
            if (this.client) {
                return this.$translate.instant('Onvio.ClientDashboard.StaffAssignments.NoAssignments', {
                    clientName: this.client.primaryContactExpanded.displayAs
                });
            }

            return '';
        }

        private loadClientAssignmentsData() {
            this.isLoading = true;

            let assignmentIds: string[] = [];
            let managerId: string;
            if (this.client.clientMainExpanded.managerEmployee && this.client.clientMainExpanded.managerEmployee.id) {
                managerId = this.client.clientMainExpanded.managerEmployee.id;
                assignmentIds.push(managerId);
            } else {
                this.manager = null;
            }

            let associateId: string;
            if (this.client.clientMainExpanded.associateEmployee && this.client.clientMainExpanded.associateEmployee.id) {
                associateId = this.client.clientMainExpanded.associateEmployee.id;
                assignmentIds.push(associateId);
            } else {
                this.associate = null;
            }

            let partnerId: string;
            let partners = this.client.clientMainExpanded.partners;
            if (partners.length > 0) {
                const defaultPartner: cs.IClientPartnerV1Dto = partners[0];
                let defaultDateEffective: number = new Date(defaultPartner.dateEffective).getTime();
                partners.forEach((partner) => {
                    if (new Date(partner.dateEffective).getTime() >= defaultDateEffective && defaultDateEffective < new Date().getTime()) {
                        defaultDateEffective = new Date(partner.dateEffective).getTime();
                        if (partner && partner?.employee?.id) {
                            partnerId = partner.employee.id;
                        } else {
                            partnerId = null;
                        }
                    }
                });
                if (partnerId) {
                    assignmentIds.push(partnerId);
                } else {
                    this.partner = null
                }
            } else {
                this.partner = null;
            }

            if (assignmentIds.length > 0) {
                this.employeeProvider.getList({
                    filter: new bmp.Filter().where('id').isInList(assignmentIds).toString(),
                    expand: 'primaryContactExpanded,primaryContactExpanded.contactImageExpanded'
                }).then((pagedItems: cs.IPagedItemsDto<cs.IEmployeeWithExpansionV3Dto>) => {
                    if (managerId) {
                        this.manager = _.find(pagedItems.items, (employee: cs.IEmployeeWithExpansionV3Dto) => employee.id === managerId);
                    }
                    if (associateId) {
                        this.associate = _.find(pagedItems.items, (employee: cs.IEmployeeWithExpansionV3Dto) => employee.id === associateId);
                    }
                    if (partnerId) {
                        this.partner = _.find(pagedItems.items, (employee: cs.IEmployeeWithExpansionV3Dto) => employee.id === partnerId);
                    }
                    this.isLoading = false;
                });
            } else {
                this.isLoading = false;
            }
        }
    }

    export class ClientAssignmentsComponent implements ng.IComponentOptions {
        bindings: any = {
            client: '<'
        };
        controller = ClientAssignmentsController;
        templateUrl = 'client-dashboard/components/client-assignments-component/client-assignments-component.html';
    }

    angular.module('onvio.clientDashboard.ClientAssignmentsComponent', [])
            .component('clientAssignments', new ClientAssignmentsComponent());
}
